import React, { useState, useEffect, useCallback } from "react";
import { Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { logout } from "../../../../utils";
import { ThreeCircles } from "react-loader-spinner";
import Select from "react-select";
import CygnusGrid from "../../../reusable_components/cygnus_grid/CygnusAgGrid";
import dayjs from "dayjs";


const TemplateSelector = (props) => {
    const [engagementLetterTemplateOptions, setEngagementLetterTemplateOptions] = useState(props.eltoptions)
    const [engagementLetterTemplate, setEngagementLetterTemplate] = useState(props.selectedelt)
    const [clientAPIProgress, setClientAPIProgress] = useState(false);

    useEffect(() => {
        if (props.eltoptions)
            setEngagementLetterTemplateOptions(props.eltoptions)
    }, [props.eltoptions])

    useEffect(() => {
        if (props.selectedelt)
            setEngagementLetterTemplate(props.selectedelt)
    }, [props.selectedelt])

    useEffect(() => {
      if(engagementLetterTemplate && engagementLetterTemplateOptions){
        setEngagementLetterTemplateOptions((prevList) =>
            prevList.map((item) =>
                item.value === engagementLetterTemplate.value ? { ...item, checked: true } : { ...item, checked: false }
            )
        )
      }
    }, [engagementLetterTemplate])
    


    // const TemplateNameRenderer = (props) => {
    //     // console.log("BTN CELL RENDERER: ", props)
    //     return (
    //         <>{removeFileExtension(props.data.TemplateOriginalFileName)}</>
    //     )
    // }
    // const DateRenderer = (props) => {
    //     // console.log("BTN CELL RENDERER: ", props)
    //     return (
    //         <>{dayjs(props.data.CreatedDate).format("MMM D, YYYY h:mm A")}</>
    //     )
    // }

    // const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setRowData] = useState([])

    // useEffect(() => {
    //     if (rowData.length !== 0) {
    //         // console.log("ROW DATA: ", rowData)
    //         let colDefs = [{
    //             field: "TemplateOriginalFileName",
    //             headerName: "Field",
    //             suppressMenu: true,
    //             cellRenderer: TemplateNameRenderer,
    //             cellStyle: { "borderRight": "0.5px solid lightgray" },
    //             checkboxSelection: true
    //         },
    //         {
    //             field: "Partner",
    //             headerName: "Partner",
    //             suppressMenu: true,
    //             flex: 1,
    //             cellStyle: { "borderRight": "0.5px solid lightgray" }
    //         },
    //         {
    //             field: "GroupName",
    //             headerName: "Connected Wizard",
    //             suppressMenu: true,
    //             flex: 1,
    //             cellStyle: { "borderRight": "0.5px solid lightgray" }
    //         },
    //         {
    //             field: "CreatedBy",
    //             headerName: "Created By",
    //             suppressMenu: true,
    //             flex: 1,
    //             cellStyle: { "borderRight": "0.5px solid lightgray" }
    //         },
    //         {
    //             field: "CreatedDate",
    //             headerName: "Created On",
    //             suppressMenu: true,
    //             flex: 1,
    //             cellRenderer: DateRenderer,
    //             cellStyle: { "borderRight": "0.5px solid lightgray" }
    //         }
    //         ]
    //         setColumnDefs(colDefs)
    //     }
    // }, [rowData])

    // useEffect(() => {
    //     console.log("API PROGRESS: ", clientAPIProgress);
    // }, [clientAPIProgress]);

    useEffect(() => {
        console.log("ENGAGEMENT LETTER TEMPLATE: ", engagementLetterTemplate)
        if (engagementLetterTemplate !== undefined && engagementLetterTemplate.length !== 0) {
            props.seteltemplate(engagementLetterTemplate)
        }
    }, [engagementLetterTemplate])



    const onChange = (template) => {
        setEngagementLetterTemplate(template)
        setEngagementLetterTemplateOptions((prevList) =>
            prevList.map((item) =>
                item.value === template.value ? { ...item, checked: true } : { ...item, checked: false }
            )
        )
    }
    return (
        <Row className="template-selector-wrapper">
            <div className="flex-column-center-center">
                <h6>Template Select</h6>
                <p>Select an appropriate template for your engagement</p>
            </div>
            {/* <label className="form-label move-left">
                {clientAPIProgress ? (
                    <>
                        <Row className="flex-row-center-center" style={{ marginLeft: 5 }}>
                            <div style={{ width: "fit-content", padding: 0 }}>
                                <ThreeCircles
                                    height="15"
                                    width="15"
                                    color="#4fa94d"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                    ariaLabel="three-circles-rotating"
                                    outerCircleColor="var(--theme1_tertiary)"
                                    innerCircleColor="var(--theme1_secondary)"
                                    middleCircleColor="var(--theme1_primary)"
                                />
                            </div>
                            <div style={{ width: "fit-content" }}>
                                Loading your templates ...
                            </div>
                        </Row>
                    </>
                ) : (
                    "Select engagement letter template"
                )}
            </label>
            <Select
                options={engagementLetterTemplateOptions}
                value={engagementLetterTemplate}
                onChange={(event) => {
                    setEngagementLetterTemplate(event);
                }}
                placeholder={"Select template"}
                aria-label="Default"
                autosize={false}
                className='custom-select '
                classNamePrefix="react-select"
            /> */}

            {/* <CygnusGrid
                columns={columnDefs}
                rows={rowData}
                selectedrows={(el) => setEngagementLetterTemplate(el)}
                noRowOverlayMessage={"No templates available. Please create engagement letter templates to use this feature."}
            /> */}

            {
                clientAPIProgress ?
                    <div
                        className="flex-row-center-center"
                        style={{ marginTop: "20%" }}
                    >
                        <div className="spinner flex-row-center-center" style={{ fontSize: 14, fontWeight: 500 }}>
                            <ThreeCircles
                                height="30"
                                width="30"
                                color="#4fa94d"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="three-circles-rotating"
                                outerCircleColor="var(--theme1_primary)"
                                innerCircleColor="var(--theme1_secondary)"
                                middleCircleColor="var(--theme1_tertiary)"
                                style={{ marginRight: 20 }}
                            />
                            <p style={{ padding: 0, margin: "0px 0px 0px 10px" }}>Loading your templates</p>
                        </div>
                    </div>
                    :
                    engagementLetterTemplateOptions.map((template, index) =>
                        <div
                            className={
                                template.checked ?
                                    "flex-row-center-start template-wrapper active-template-wrapper"
                                    : "flex-row-center-start template-wrapper"}
                            onClick={() => onChange(template)}
                        >
                            <input
                                type="radio"
                                className={"form-check-input move-left custom-check-input"}
                                id={template.checked}
                                checked={template.checked}
                                defaultChecked={false}
                            />
                            {template.label} {template.CreatedBy ? "-" : ""} {template.CreatedBy}
                        </div>
                    )
            }
        </Row>
    );
};

export default TemplateSelector;
